// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"5140a832","425":"33d6d53f","472":"565711e3","519":"8b075595","558":"6b74adf4","661":"ebfd51d6","985":"1ca61990"}[chunkId] + ".chunk.js";
};